import { useFormContext } from 'react-hook-form';
import { Typography } from '@material-ui/core';

export const NutritionistSearchTestStep5Form = () => {
  const form = useFormContext();

  return <Typography>Step 5 form</Typography>;
};
